// import React, { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import Page from "../components/Page";
// import { iconStroke } from "../config/config";
// import { IconArmchair, IconBoxSeam, IconCheck, IconChecks, IconClock, IconRefresh, IconX } from "@tabler/icons-react";
// import { getKitchenOrders, updateKitchenOrderItemStatus } from "../controllers/kitchen.controller";
// import { toast } from "react-hot-toast";
// import { initSocket, getSocket } from "../utils/socket";   // NEW
// import { textToSpeech } from "../utils/textToSpeech";
// import { getUserDetailsInLocalStorage } from "../helpers/UserDetails";
// import { useTheme } from "../contexts/ThemeContext";

// export default function KitchenPage() {
//   const { t } = useTranslation();
//   const user = getUserDetailsInLocalStorage();
//   const { theme } = useTheme();

//   const [state, setState] = useState({
//     kitchenOrders: [],
//     isLoading: true,
//   });

//   const { kitchenOrders, isLoading } = state;

//   /* --------------------------------------------------------------- */
//   /* 1. Init data + socket                                           */
//   /* --------------------------------------------------------------- */
//   useEffect(() => {
//     _init();               // load orders
//     initSocket();          // start socket (uses token from localStorage)

//     const socket = getSocket();
//     if (!socket) return;

//     const audio = new Audio("/new_order_sound.mp3");

//     const onNewOrder = (payload) => {
//       console.log("new_order", payload);
//       audio.play();
//       btnRefresh();
//     };

//     const onOrderUpdate = () => {
//       console.log("order_update");
//       btnRefresh();
//     };

//     socket.on("new_order", onNewOrder);
//     socket.on("order_update", onOrderUpdate);

//     // Authenticate the kitchen for this tenant
//     socket.emit("authenticate", user.tenant_id);

//     return () => {
//       socket.off("new_order", onNewOrder);
//       socket.off("order_update", onOrderUpdate);
//     };
//   }, []);   // run once

//   /* --------------------------------------------------------------- */
//   /* 2. Load orders                                                   */
//   /* --------------------------------------------------------------- */
  function groupKitchenOrders(orders) {
    if (!orders) return [];
    const groupedOrders = [];
    for (const order of orders) {
      let orderIndex = -1;
      if (order.delivery_type === "room" && order.source) {
        orderIndex = groupedOrders.findIndex(o => o.delivery_type === "room" && o.source === order.source);
      } else if (order.table_id) {
        orderIndex = groupedOrders.findIndex(o => o.table_id === order.table_id);
      } else {
        orderIndex = -1;
      }
      if (orderIndex === -1) {
        groupedOrders.push({ ...order, items: [...order.items] });
      } else {
        groupedOrders[orderIndex].items.push(...order.items);
        if (!String(groupedOrders[orderIndex].token_no).includes(String(order.token_no))) {
          groupedOrders[orderIndex].token_no = `${groupedOrders[orderIndex].token_no}, ${order.token_no}`;
        }
      }
    }
    return groupedOrders;
  }

//   const _init = async () => {
//     try {
//       const res = await getKitchenOrders();
//       if (res.status === 200) {
//         setState((s) => ({
//           ...s,
//           kitchenOrders: res.data || [],
//           isLoading: false,
//         }));
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error(t("kitchen.error_loading_orders"));
//       setState((s) => ({ ...s, isLoading: false }));
//     }
//   };

//   /* --------------------------------------------------------------- */
//   /* 3. Refresh (manual)                                              */
//   /* --------------------------------------------------------------- */
//   const btnRefresh = async () => {
//     toast.loading(t("kitchen.loading_message"));
//     try {
//       const res = await getKitchenOrders();
//       toast.dismiss();
//       if (res.status === 200) {
//         setState((s) => ({
//           ...s,
//           kitchenOrders: res.data || [],
//           isLoading: false,
//         }));
//       }
//     } catch (error) {
//       toast.dismiss();
//       toast.error(t("kitchen.error_loading_orders"));
//       setState((s) => ({ ...s, isLoading: false }));
//     }
//   };

//   /* --------------------------------------------------------------- */
//   /* 4. Order item actions                                            */
//   /* --------------------------------------------------------------- */
//   const sendOrderUpdateEvent = () => {
//     const socket = getSocket();
//     if (socket?.connected) {
//       socket.emit("order_update_backend", {}, user.tenant_id);
//     }
//   };

//   const btnStartPreparingOrderItem = async (orderItemId) => {
//     toast.loading(t("kitchen.loading_message"));
//     try {
//       const res = await updateKitchenOrderItemStatus(orderItemId, "preparing");
//       toast.dismiss();
//       if (res.status === 200) {
//         await btnRefresh();
//         sendOrderUpdateEvent();
//         toast.success(res.data.message);
//       }
//     } catch (error) {
//       toast.dismiss();
//       toast.error(error?.response?.data?.message || t("kitchen.error_processing_request"));
//     }
//   };

//   const btnCompletePreparingOrderItem = async (orderItemId) => {
//     toast.loading(t("kitchen.loading_message"));
//     try {
//       const res = await updateKitchenOrderItemStatus(orderItemId, "completed");
//       toast.dismiss();
//       if (res.status === 200) {
//         sendOrderUpdateEvent();
//         await btnRefresh();
//         toast.success(res.data.message);
//       }
//     } catch (error) {
//       toast.dismiss();
//       toast.error(error?.response?.data?.message || t("kitchen.error_processing_request"));
//     }
//   };

//   /* --------------------------------------------------------------- */
//   /* 5. Filter active orders                                          */
//   /* --------------------------------------------------------------- */
//   const filteredOrders = kitchenOrders.filter(
//     (order) => !order.items.every((i) => i.status === "completed" || i.status === "delivered")
//   );

//   /* --------------------------------------------------------------- */
//   /* 6. UI                                                            */
//   /* --------------------------------------------------------------- */
//   return (
//     <Page>
//       <div className="flex items-center gap-6">
//         <h3 className="text-3xl font-light">{t("kitchen.title")}</h3>
//         <button
//           onClick={btnRefresh}
//           className={`dark:rounded-lg border-none shadow-none transition active:scale-95 text-gray-500 px-2 py-1 flex items-center gap-1 ${
//             theme === "black"
//               ? "bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode text-white"
//               : "bg-gray-50 hover:bg-gray-100 rounded-lg"
//           }`}
//         >
//           <IconRefresh size={22} stroke={iconStroke} /> {t("kitchen.refresh")}
//         </button>
//       </div>

//       {isLoading && <p>{t("kitchen.loading_message")}</p>}

//       {filteredOrders.length === 0 && (
//         <div className="w-full h-[calc(100vh-15vh)] flex gap-4 flex-col items-center justify-center">
//           <img
//             src="/assets/illustrations/kitchen-order-not-found.webp"
//             alt={t("kitchen.no_orders_img_alt")}
//             className="w-1/2 md:w-60"
//           />
//           <p className="text-gray-400 text-center">{t("kitchen.no_pending_orders")}</p>
//         </div>
//       )}

//       {filteredOrders.length > 0 && (
//         <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
//           {filteredOrders.map((order, index) => {
//             const {
//               id,
//               delivery_type,
//               table_title,
//               floor,
//               token_no,
//               items,
//             } = order;

//             return (
//               <div
//                 key={index}
//                 className="border rounded-2xl px-4 py-5 flex flex-col border-restro-border-green"
//               >
//                 <div className="flex items-center flex-col md:flex-row md:justify-between text-center gap-2">
//                   <div className="flex items-center gap-2">
//                     <div className="flex w-12 h-12 rounded-full items-center justify-center bg-restro-gray text-restro-text">
//                       {delivery_type === "dinein" ? (
//                         <IconArmchair size={24} stroke={iconStroke} />
//                       ) : (
//                         <IconBoxSeam size={24} stroke={iconStroke} />
//                       )}
//                     </div>
//                     <div>
//                       <p className="font-bold">{table_title || `${delivery_type.toUpperCase()}`}</p>
//                       {floor && <p className="text-sm">{floor}</p>}
//                     </div>
//                   </div>
//                   <div className="text-end">
//                     <p className="font-bold">
//                       {t("kitchen.token")} {token_no}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="mt-4 flex flex-col divide-y dark:divide-restro-gray">
//                   {items.map((item) => {
//                     const {
//                       id: orderItemId,
//                       item_title,
//                       variant_title,
//                       quantity,
//                       status,
//                       addons,
//                       notes,
//                     } = item;

//                     const addonsText = addons?.length
//                       ? addons.map((a) => a.title).join(", ")
//                       : null;

//                     return (
//                       <div key={orderItemId} className="flex items-center gap-2 py-2">
//                         {/* status icon */}
//                         {status === "preparing" && <IconClock stroke={iconStroke} className="text-amber-500" />}
//                         {status === "completed" && <IconCheck stroke={iconStroke} className="text-green-500" />}
//                         {status === "cancelled" && <IconX stroke={iconStroke} className="text-red-500" />}
//                         {status === "delivered" && <IconChecks stroke={iconStroke} className="text-green-500" />}

//                         {/* item info */}
//                         <div className="flex-1">
//                           <p>
//                             {item_title} {variant_title} x {quantity}
//                           </p>
//                           {addonsText && (
//                             <p className="text-sm text-gray-700 dark:text-white">
//                               {t("kitchen.notes")} {addonsText}
//                             </p>
//                           )}
//                           {notes && (
//                             <p className="text-sm text-gray-700 dark:text-white">
//                               {t("kitchen.notes")} {notes}
//                             </p>
//                           )}
//                         </div>

//                         {/* actions */}
//                         {status === "created" && (
//                           <button
//                             onClick={() => btnStartPreparingOrderItem(orderItemId)}
//                             className="btn btn-sm border transition active:scale-95 hover:shadow-lg rounded-lg border-restro-border-green text-restro-text hover:bg-restro-button-hover"
//                           >
//                             {t("kitchen.start_making")}
//                           </button>
//                         )}
//                         {status === "preparing" && (
//                           <button
//                             onClick={() => btnCompletePreparingOrderItem(orderItemId)}
//                             className="btn btn-sm border transition active:scale-95 hover:shadow-lg rounded-lg border-restro-border-green text-restro-text hover:bg-restro-button-hover"
//                           >
//                             {t("kitchen.complete")}
//                           </button>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </Page>
//   );
// }

import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Page from "../components/Page";
import { iconStroke } from "../config/config";
import { IconArmchair, IconBed, IconBoxSeam, IconCheck, IconChecks, IconClock, IconRefresh, IconX } from "@tabler/icons-react";
import { getKitchenOrders, updateKitchenOrderItemStatus, useKitchenOrders } from "../controllers/kitchen.controller";
import { toast } from "react-hot-toast";
import { SocketContext } from "../contexts/SocketContext";
import { initSocket } from "../utils/socket";
import { textToSpeech } from "../utils/textToSpeech";
import { getUserDetailsInLocalStorage } from "../helpers/UserDetails";
import { useTheme } from "../contexts/ThemeContext";
import { groupItemsByPrinter, printKOT } from "../helpers/PrinterHelper";
import ApiClient from "../helpers/ApiClient";
import { playKitchenNewOrderSound, playItemCancelledSound, unlockAudio, isAudioUnlocked } from "../helpers/SoundHelper";


export default function KitchenPage() {
  const { t } = useTranslation();
  const user = getUserDetailsInLocalStorage();
  const { socket, isSocketConnected } = useContext(SocketContext);
  const { theme } = useTheme();
  
  const [state, setState] = useState({
    kitchenOrders: [],
    categories: [],
    isLoading: true,
  });

  const { kitchenOrders, categories, isLoading } = state;

  const [audioActive, setAudioActive] = useState(isAudioUnlocked());
  const [cancelModal, setCancelModal] = useState({
    isOpen: false,
    orderItemId: null,
    itemTitle: "",
    totalQty: 1,
    cancelQty: 1,
    reason: "Out of stock / ingredients finished",
    customReason: "",
    isSubmitting: false
  });

  function groupKitchenOrders(orders) {
    if (!orders) return [];
    const groupedOrders = [];
    for (const order of orders) {
      let orderIndex = -1;
      if (order.delivery_type === "room" && order.source) {
        orderIndex = groupedOrders.findIndex(o => o.delivery_type === "room" && o.source === order.source);
      } else if (order.table_id) {
        orderIndex = groupedOrders.findIndex(o => o.table_id === order.table_id);
      } else {
        orderIndex = -1;
      }
      if (orderIndex === -1) {
        groupedOrders.push({ ...order, items: [...order.items] });
      } else {
        groupedOrders[orderIndex].items.push(...order.items);
        if (!String(groupedOrders[orderIndex].token_no).includes(String(order.token_no))) {
          groupedOrders[orderIndex].token_no = `${groupedOrders[orderIndex].token_no}, ${order.token_no}`;
        }
      }
    }
    return groupedOrders;
  }

  const _init = async () => {
    try {
      const res = await getKitchenOrders();

      if(res.status == 200) {
        const orders = res?.data || [];
        
        // Also fetch categories for printer info
        const catRes = await ApiClient.get("/settings/categories");

        setState({
          ...state,
          kitchenOrders: groupKitchenOrders(orders) || [],
          categories: catRes.data || [],
          isLoading: false,
        });
      }

    } catch (error) {
      console.error(error);
      toast.dismiss();
      toast.error(t('kitchen.error_loading_orders'));

      setState({
        ...state,
        isLoading: false,
      });
    }
  };

  const btnShowCancelModal = (orderItemId, itemTitle, totalQty = 1) => {
    setCancelModal({
      isOpen: true,
      orderItemId,
      itemTitle,
      totalQty: Number(totalQty) || 1,
      cancelQty: 1,
      reason: "Out of stock / ingredients finished",
      customReason: "",
      isSubmitting: false
    });
  };

  const btnConfirmCancelItem = async () => {
    if (!cancelModal.orderItemId) return;
    const finalReason = cancelModal.reason === "Other Reason" 
      ? (cancelModal.customReason || "Cancelled by kitchen")
      : (cancelModal.reason || "Cancelled by kitchen");

    try {
      setCancelModal(prev => ({ ...prev, isSubmitting: true }));
      toast.loading(t('kitchen.loading_message'));

      const res = await updateKitchenOrderItemStatus(
        cancelModal.orderItemId, 
        'cancelled', 
        finalReason, 
        cancelModal.cancelQty
      );

      toast.dismiss();
      if (res.status === 200) {
        setCancelModal(prev => ({ ...prev, isOpen: false }));
        unlockAudio();
        setAudioActive(true);
        playItemCancelledSound({ itemTitle: cancelModal.itemTitle, reason: finalReason });
        toast.success(`Cancelled ${cancelModal.cancelQty} x ${cancelModal.itemTitle}`);
        await btnRefresh();
        sendOrderUpdateEvent();
      }
    } catch (error) {
      toast.dismiss();
      const message = error?.response?.data?.message || t('kitchen.error_processing_request');
      toast.error(message);
      setCancelModal(prev => ({ ...prev, isSubmitting: false }));
    }
  };

  useEffect(() => {
    _init();
  }, []);

  useEffect(() => {
    if (!socket) return;

    if (user?.tenant_id) {
      socket.emit("authenticate", user.tenant_id);
    }

    const onConnect = () => {
      if (user?.tenant_id) {
        socket.emit("authenticate", user.tenant_id);
      }
    };

    const handleNewOrder = async (payload) => {
      console.log("New Order Received in Kitchen:", payload);
      unlockAudio();
      setAudioActive(true);
      playKitchenNewOrderSound({
        tokenNo: payload?.tokenNo,
        tableTitle: payload?.tableTitle || payload?.table_title,
        tableId: payload?.tableId,
        deliveryType: payload?.deliveryType,
        source: payload?.source
      });

      const tokenText = payload?.tokenNo ? `Token #${payload.tokenNo}` : (payload?.orderId ? `Order #${payload.orderId}` : '');
      const sourceText = payload?.source || (payload?.deliveryType === 'room' ? 'Room Service' : (payload?.tableId ? `Table ${payload.tableId}` : 'New Order'));

      toast.custom((t) => (
        <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} max-w-md w-full bg-emerald-600 shadow-2xl rounded-2xl pointer-events-auto flex ring-2 ring-emerald-400 p-4 text-white items-center justify-between`}>
          <div className="flex items-center gap-3">
            <span className="text-3xl animate-bounce">🍳</span>
            <div>
              <p className="text-base font-extrabold uppercase tracking-wide">New Order for Kitchen!</p>
              <p className="text-sm font-medium opacity-90">{sourceText} {tokenText ? `(${tokenText})` : ''}</p>
            </div>
          </div>
          <button onClick={() => toast.dismiss(t.id)} className="ml-3 text-white text-xl font-bold bg-white/20 hover:bg-white/30 rounded-full w-8 h-8 flex items-center justify-center">✕</button>
        </div>
      ), { duration: 8000 });

      const updatedOrders = await btnRefresh();
      
      if (payload && payload.orderId && updatedOrders) {
         const newOrder = updatedOrders.find(o => o.id == payload.orderId);
         if (newOrder) {
            const { categories } = state;
            const printerGroups = groupItemsByPrinter(newOrder.items, categories);
            if (localStorage.getItem('kdsAutoPrint') !== 'false') printKOT(printerGroups, {
              tableId: newOrder.table_id,
              table_title: newOrder.table_title,
              tokenNo: newOrder.token_no,
              orderId: newOrder.id,
              customerName: newOrder.customer_name
            });
         }
      }
    };

    const handleItemCancelled = (payload) => {
      console.log("Kitchen Display received cancellation alert:", payload);
      unlockAudio();
      setAudioActive(true);
      playItemCancelledSound({
        reason: payload?.cancelReason,
        itemTitle: payload?.itemTitle,
        tableTitle: payload?.tableTitle
      });

      const reasonText = payload?.cancelReason ? `: ${payload.cancelReason}` : '';
      toast.custom((t) => (
        <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} max-w-md w-full bg-red-600 shadow-2xl rounded-2xl pointer-events-auto flex ring-2 ring-red-400 p-4 text-white items-center justify-between`}>
          <div className="flex items-center gap-3">
            <span className="text-3xl animate-bounce">🚨</span>
            <div>
              <p className="text-base font-extrabold uppercase tracking-wide">Item Cancelled by Staff!</p>
              <p className="text-sm font-medium opacity-90">{payload?.cancelReason || 'Cancelled in POS/Orders'}</p>
            </div>
          </div>
          <button onClick={() => toast.dismiss(t.id)} className="ml-3 text-white text-xl font-bold bg-white/20 hover:bg-white/30 rounded-full w-8 h-8 flex items-center justify-center">✕</button>
        </div>
      ), { duration: 9000 });

      btnRefresh();
    };

    const handleOrderUpdate = (payload) => {
      console.log("Kitchen Order update:", payload);
      if (payload?.type === 'item_cancelled' || payload?.type === 'order_cancelled') {
        handleItemCancelled(payload);
      } else {
        btnRefresh();
      }
    };

    socket.on('connect', onConnect);
    socket.on('new_order', handleNewOrder);
    socket.on('new_qrorder', handleNewOrder);
    socket.on('new_order_notification', handleNewOrder);
    socket.on('order_update', handleOrderUpdate);
    socket.on('order_item_cancelled', handleItemCancelled);
    socket.on('order_cancelled', handleItemCancelled);

    return () => {
      socket.off('connect', onConnect);
      socket.off('new_order', handleNewOrder);
      socket.off('new_qrorder', handleNewOrder);
      socket.off('new_order_notification', handleNewOrder);
      socket.off('order_update', handleOrderUpdate);
      socket.off('order_item_cancelled', handleItemCancelled);
      socket.off('order_cancelled', handleItemCancelled);
    };
  }, [socket, isSocketConnected]);

  const sendOrderUpdateEvent = () => {
    const user = getUserDetailsInLocalStorage();

    if (isSocketConnected) {
      socket.emit('order_update_backend', {}, user.tenant_id);
    } else {
      // Handle disconnected state (optional)
      initSocket();
      socket.emit('order_update_backend', {}, user.tenant_id);
    }
  }

  async function btnRefresh() {
    try {
      toast.loading(t('kitchen.loading_message'));
      const res = await getKitchenOrders();

      if(res.status == 200) {
        toast.dismiss();
        const orders = res?.data || [];

        setState(prev => ({
          ...prev,
          kitchenOrders: groupKitchenOrders(orders) || [],
          isLoading: false,
        }));
        return orders;
      }

    } catch (error) {
      console.error(error);
      toast.dismiss();
      toast.error(t('kitchen.error_loading_orders'));

      setState({
        ...state,
        isLoading: false,
      });
    }
  }

  const btnStartPreparingOrderItem = async (orderItemId) => {
    try {
      toast.loading(t('kitchen.loading_message'));
      const res = await updateKitchenOrderItemStatus(orderItemId, 'preparing');
      toast.dismiss();
      if(res.status == 200) {
        await btnRefresh();
        sendOrderUpdateEvent();
        toast.success(res.data.message);
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('kitchen.error_processing_request');
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  }
  const btnCompletePreparingOrderItem = async (orderItemId) => {
    try {
      toast.loading(t('kitchen.loading_message'));
      const res = await updateKitchenOrderItemStatus(orderItemId, 'completed');
      toast.dismiss();
      if(res.status == 200) {
        sendOrderUpdateEvent();
        await btnRefresh();
        toast.success(res.data.message);
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('kitchen.error_processing_request');
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  }

  const filteredOrders = kitchenOrders.filter(order => {
    return !order.items.every(item => item.status === 'completed' || item.status === 'delivered');
  });

  return (
    <Page>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <h3 className="text-3xl font-light">{t('kitchen.title')}</h3>
          <button
            onClick={btnRefresh}
            className={`dark:rounded-lg border-none shadow-none transition active:scale-95 text-gray-500 px-3 py-1.5 flex items-center gap-1.5 ${theme === 'black' ? 'bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode text-white' : 'bg-gray-50 hover:bg-gray-100 rounded-lg'}`}
          >
            <IconRefresh size={20} stroke={iconStroke} /> {t('kitchen.refresh')}
          </button>
        </div>

        {/* Audio Verification & Test Button */}
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => {
              unlockAudio();
              setAudioActive(true);
              playItemCancelledSound({ itemTitle: "Test Cancel Alarm" });
              toast.success("🔊 Kitchen audio active & tested!");
            }}
            className={`px-3.5 py-1.5 rounded-xl flex items-center gap-2 text-xs font-bold transition border shadow-sm ${
              audioActive 
                ? "bg-green-50 text-green-700 border-green-300 dark:bg-green-950/40 dark:text-green-300 dark:border-green-800 hover:bg-green-100" 
                : "bg-amber-100 text-amber-900 border-amber-400 animate-pulse hover:bg-amber-200"
            }`}
            title="Click to test buzzer sound and ensure audio is unmuted"
          >
            {audioActive ? "🔊 Sound Active (Test Alert)" : "🔇 Tap to Enable Audio Alerts"}
          </button>
        </div>
      </div>

      {/* Browser Autoplay Requirement Notice Banner */}
      {!audioActive && (
        <div
          onClick={() => {
            unlockAudio();
            setAudioActive(true);
            playItemCancelledSound({ itemTitle: "Sound Activated" });
            toast.success("🔊 Kitchen sound alerts unmuted!");
          }}
          className="mt-3 cursor-pointer bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 hover:opacity-95 transition text-white px-4 py-3 rounded-2xl flex items-center justify-between shadow-lg ring-2 ring-amber-300/50"
        >
          <div className="flex items-center gap-3">
            <span className="text-2xl animate-bounce">🔔</span>
            <div>
              <p className="font-extrabold text-sm">Browser requires 1 tap to play kitchen cancellation sounds</p>
              <p className="text-xs opacity-95">Tap anywhere on this banner to activate real-time cancellation buzzer & order chimes</p>
            </div>
          </div>
          <button type="button" className="bg-white text-amber-900 font-extrabold text-xs px-3.5 py-1.5 rounded-xl shadow">
            Enable Audio Now
          </button>
        </div>
      )}

      {isLoading && <p>{t('kitchen.loading_message')}</p>}

      {filteredOrders?.filter(order => {
            return !order.items.every(item => item.status === 'completed' || item.status === 'delivered');
          })?.length == 0 && (
        <div className="w-full h-[calc(100vh-15vh)] flex gap-4 flex-col items-center justify-center">
          <img
            src="/assets/illustrations/kitchen-order-not-found.webp"
            alt={t('kitchen.no_orders_img_alt')}
            className="w-1/2 md:w-60"
          />
          <p className="text-gray-400 text-center">{t('kitchen.no_pending_orders')}</p>
        </div>
      )}

      {
        filteredOrders?.length > 0 && <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4">

        {
          filteredOrders.map((order, index)=>{

            const {
              id,
              date,
              delivery_type,
              customer_type,
              customer_id,
              customer_name,
              table_id,
              table_title,
              floor,
              status,
              payment_status,
              token_no,
              items,
              source,
            } = order;

            const isRoom = delivery_type === "room" || !!source || (table_title && table_title.toLowerCase().startsWith('room'));
            const roomDisplay = source || (table_title ? table_title.replace(/^room\s*/i, '') : '');
            const diningTitle = isRoom
              ? (roomDisplay ? (roomDisplay.toLowerCase().startsWith('room') ? roomDisplay : `Room ${roomDisplay}`) : 'Room Order')
              : (table_id ? `${table_title}` : `${(delivery_type || '').toUpperCase()} ${(customer_type || '').toUpperCase()}`.trim());
            const displayFloor = isRoom ? (floor || "Room Service") : floor;

            return <div key={index} className='border  rounded-2xl px-4 py-5 flex flex-col border-restro-border-green'>
              <div className="flex items-center flex-col md:flex-row md:justify-between text-center gap-2">
                <div className="flex items-center gap-2">
                  <div className='flex w-12 h-12 rounded-full items-center justify-center bg-restro-gray text-restro-text'>
                    {isRoom ? <IconBed size={24} stroke={iconStroke} className="text-amber-500" /> : delivery_type == "dinein" ? <IconArmchair size={24} stroke={iconStroke} /> : <IconBoxSeam size={24} stroke={iconStroke} />}
                  </div>
                  <div>
                    <p className="font-bold">{diningTitle}</p>
                    {displayFloor && <p className="text-sm">{displayFloor}</p>}
                  </div>
                </div>
                <div className="text-end">
                  <p className="font-bold">{t('kitchen.token')} {token_no}</p>
                </div>
              </div>

              {/* order items */}
              <div className="mt-4 flex flex-col divide-y dark:divide-restro-gray">
                {
                  items.map((item, index)=>{
                    const {
                      id: orderItemId,
                      order_id,
                      item_id,
                      item_title,
                      variant_id,
                      variant_title,
                      quantity,
                      status,
                      date,
                      addons,
                      notes,
                    } = item;

                    const addonsText = addons?.length > 0 ? addons?.map((a)=>a?.title)?.filter(Boolean)?.join(", "):null;

                    return  <div key={index} className="flex items-center gap-2 py-2">
                      {/* status */}
                      {status == "preparing" && <IconClock stroke={iconStroke} className="text-amber-500" />}
                      {status == "completed" && <IconCheck stroke={iconStroke} className="text-green-500" />}
                      {status == "cancelled" && <IconX stroke={iconStroke} className="text-red-500" />}
                      {status == "delivered" && <IconChecks stroke={iconStroke} className="text-green-500" />}
                      {/* status */}

                      {/* item title */}
                      <div className="flex-1">
                        <p>{item_title} {variant_title} x {quantity}</p>
                        {addonsText && <p className="text-sm text-gray-700 dark:text-white">{t('kitchen.notes')} {addonsText}</p>}
                        {notes && <p className="text-sm text-gray-700 dark:text-white">{t('kitchen.notes')} {notes}</p>}
                      </div>
                      {/* item title */}

                      {/* action */}
                      <div className="flex items-center gap-1.5">
                        {(status == "pending" || status == "created") && (
                          <button onClick={()=>{btnStartPreparingOrderItem(orderItemId)}} className='btn btn-sm border transition active:scale-95 hover:shadow-lg rounded-lg border-restro-border-green text-restro-text hover:bg-restro-button-hover'>{t('kitchen.start_making')}</button>
                        )}
                        {status == "preparing" && (
                          <button onClick={()=>{btnCompletePreparingOrderItem(orderItemId)}}  className='btn btn-sm border transition active:scale-95 hover:shadow-lg rounded-lg border-restro-border-green text-restro-text hover:bg-restro-button-hover'>{t('kitchen.complete')}</button>
                        )}
                        {(status == "pending" || status == "created" || status == "preparing") && (
                          <button 
                            type="button"
                            onClick={() => btnShowCancelModal(orderItemId, `${item_title} ${variant_title || ''}`.trim(), quantity)} 
                            title="Cancel this item"
                            className='btn btn-sm btn-ghost text-red-500 hover:bg-red-50 dark:hover:bg-red-950/40 rounded-lg p-1.5 transition active:scale-90'
                          >
                            <IconX size={18} stroke={iconStroke} />
                          </button>
                        )}
                      </div>
                      {/* action */}
                    </div>
                  })
                }

              </div>
              {/* order items */}
            </div>

          })
        }

      </div>
      }

      {/* Cancel Item Modal */}
      {cancelModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xs p-4 animate-fade-in">
          <div className="bg-white dark:bg-restro-gray rounded-2xl shadow-2xl max-w-md w-full p-6 border border-gray-100 dark:border-gray-800 space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-gray-100 dark:border-gray-700">
              <div className="flex items-center gap-2 text-red-600 dark:text-red-400">
                <IconX size={24} stroke={2.5} />
                <h4 className="text-lg font-bold">Cancel Order Item</h4>
              </div>
              <button 
                type="button"
                onClick={() => setCancelModal(prev => ({ ...prev, isOpen: false }))}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition"
              >
                <IconX size={20} />
              </button>
            </div>

            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Item to cancel:</p>
              <p className="text-base font-bold text-gray-800 dark:text-white mt-0.5">{cancelModal.itemTitle}</p>
            </div>

            {cancelModal.totalQty > 1 && (
              <div>
                <label className="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">
                  Quantity to Cancel (Total: {cancelModal.totalQty})
                </label>
                <div className="flex items-center gap-3">
                  <input
                    type="number"
                    min="1"
                    max={cancelModal.totalQty}
                    value={cancelModal.cancelQty}
                    onChange={(e) => {
                      const val = Math.max(1, Math.min(cancelModal.totalQty, parseInt(e.target.value) || 1));
                      setCancelModal(prev => ({ ...prev, cancelQty: val }));
                    }}
                    className="w-24 px-3 py-2 border rounded-xl dark:bg-restro-border-green/10 dark:border-gray-700 text-center font-bold text-lg"
                  />
                  <span className="text-xs text-gray-500">out of {cancelModal.totalQty}</span>
                </div>
              </div>
            )}

            <div>
              <label className="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">
                Reason for Cancellation
              </label>
              <select
                value={cancelModal.reason}
                onChange={(e) => setCancelModal(prev => ({ ...prev, reason: e.target.value }))}
                className="w-full px-3 py-2.5 border rounded-xl dark:bg-restro-border-green/10 dark:border-gray-700 text-sm font-medium"
              >
                <option value="Out of stock / ingredients finished">Out of stock / ingredients finished</option>
                <option value="Customer changed mind">Customer changed mind</option>
                <option value="Kitchen equipment issue">Kitchen equipment issue</option>
                <option value="Accidental order / wrong entry">Accidental order / wrong entry</option>
                <option value="Other Reason">Other Reason</option>
              </select>
            </div>

            {cancelModal.reason === "Other Reason" && (
              <div>
                <label className="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">
                  Specify Reason
                </label>
                <textarea
                  rows="2"
                  value={cancelModal.customReason}
                  onChange={(e) => setCancelModal(prev => ({ ...prev, customReason: e.target.value }))}
                  placeholder="Enter reason..."
                  className="w-full px-3 py-2 border rounded-xl dark:bg-restro-border-green/10 dark:border-gray-700 text-sm"
                />
              </div>
            )}

            <div className="flex items-center justify-end gap-3 pt-2">
              <button
                type="button"
                onClick={() => setCancelModal(prev => ({ ...prev, isOpen: false }))}
                disabled={cancelModal.isSubmitting}
                className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800 rounded-xl transition"
              >
                Close
              </button>
              <button
                type="button"
                onClick={btnConfirmCancelItem}
                disabled={cancelModal.isSubmitting}
                className="px-5 py-2 text-sm font-bold text-white bg-red-600 hover:bg-red-700 active:scale-95 rounded-xl shadow transition flex items-center gap-2"
              >
                {cancelModal.isSubmitting ? "Cancelling..." : "Confirm Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
    </Page>
  );
}
